import { CommonModule, registerLocaleData } from '@angular/common'
import localePt from '@angular/common/locales/pt'
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'
import { MatPaginatorIntl } from '@angular/material/paginator'
import { ServiceWorkerModule } from '@angular/service-worker'
import { UnespCoreHomeModule, UnespCoreModule } from '@unesp/core'

import { environment } from 'src/environments/environment'
import { PtBrMatPaginatorIntl } from './pt-br-paginator-intl'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { menu } from './menus/menu'
import { InterceptorsModule } from './interceptors/interceptors.module'

import { CacheService } from './shared/services/cache.service'
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2'
import { MatDialogModule } from '@angular/material/dialog'
import { LocalStorageService } from './shared/services/local-storage.service'
import { getMenuAlunoRegular } from './menus/menu-aluno-regular'
import { menuAlunoEspecial } from './menus/menu-aluno-especial'
import { menuCandidato } from './menus/menu-candidato'
import { menuPropg } from './menus/menu-propg'
import { menuStpg } from './menus/menu-stpg'
// import { menuArex } from './menus/menu-arex'
// import { menuCcd } from './menus/menu-ccd'
// import { menuConsultaDiscente } from './menus/menu-consulta-discente'
// import { menuDta } from './menus/menu-dta'
// import { menuDocente } from './menus/menu-docente'

registerLocaleData(localePt, 'pt')

@NgModule({
  declarations: [AppComponent],
  providers: [
    { provide: 'environment', useValue: environment },
    // { provide: 'menu', useValue: menu },
    {
      provide: 'menu',
      deps: [LocalStorageService],
      useFactory: (localStorageService: LocalStorageService) => {
        const perfil = localStorageService.get('perfil')
        const user = localStorageService.get('user')
        if (!user) {
          return menu
        } else {
          switch (perfil) {
            case 'ALUNO_REGULAR':
              return getMenuAlunoRegular(localStorageService.get('identificacaoUsuario'))
            case 'ALUNO_ESPECIAL':
              return menuAlunoEspecial
            case 'STPG':
              return menuStpg
            case 'AREX':
              return menu
            case 'CANDIDATO':
              return menuCandidato
            case 'CCD':
              return menu
            case 'CONSULTA_DISCENTE':
              return menu
            case 'DTA':
              return menu
            case 'PROPG':
              return menuPropg
            case 'DOCENTE':
              return menu
            default:
              return menu
          }
        }
      },
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: MatPaginatorIntl, useValue: PtBrMatPaginatorIntl() },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    CacheService,
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    UnespCoreModule,
    UnespCoreHomeModule,
    InterceptorsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    FlexLayoutModule,
    RecaptchaV3Module,
    MatDialogModule,
  ],
})
export class AppModule {}
